var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.se_quiere_editar_stock)?_c('edit-address-stock',{attrs:{"article":_vm.article,"address":_vm.address}}):_c('span',[_vm._v(" "+_vm._s(_vm.get_address_stock(_vm.article, _vm.address))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }